module.exports = __webpack_public_path__ + "media/gender-wayang.686e6f0b.mp3";